import { lazy } from "react";

let org;
const OrgComponent = lazy(() => import(`./${org}/Index`))

export const Index = (params) => {
    const orgname = params.match.params.orgname
    const feature = params.match.params.feature
    org = orgname

    return (
        <OrgComponent orgname={orgname} feature={feature}/>
    )
}